import { useLocation } from "react-router-dom";

export const useBackUrl = () => {
    const location = useLocation();

    const backUrl = () => {
        return (location.state as { from?: string })?.from || "/";
    };

    return backUrl;
};
